import { useState } from 'react';
import { useEffectAfterFirstRender } from './useEffectAfterFirstRender';
import { useRequest } from './useRequest';
export function useMergedRequest({ deps, initial, request, merge, }) {
    const [mergedResponse, setMergedResponse] = useState(() => merge(undefined, initial));
    const { response, status } = useRequest({
        deps,
        initial,
        request,
    });
    useEffectAfterFirstRender(() => setMergedResponse((existing) => merge(existing, response)), [response]);
    return {
        response: mergedResponse,
        status,
    };
}
